import styled from 'styled-components';

export const TitleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
  margin-bottom: 20px;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;

  label {
    font-weight: bold;
    margin-bottom: 5px;
    color: #333;
    display: block;
  }

  input, select {
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #ccc;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
`;

export const Tab = styled.button<{ $active?: boolean }>`
  background: none;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: bold;
  color: ${props => props.$active ? '#007bff' : '#666'};
  border-bottom: 3px solid ${props => props.$active ? '#007bff' : 'transparent'};
`;

export const SearchResult = styled.div`
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    background: #f5f5f5;
  }
`;
